import PlayerAvatar from "../user/avatar";
import { getApproximateTimeString } from "@/src/util/relativetime";
import { useState } from "react";
import styles from './news.module.css';
import HomeNewsPostDeleteButton from "./newspostdeletebutton";

type Props = {
    newsPostId: number;
    title: string;
    authorName: string | null;
    authorAvatar?: string | null;
    date: number;
    content: string;
    onDeletePost: (newsPostId: number) => void;
}

export default function NewsPost(
    {
        title,
        authorName,
        authorAvatar,
        date,
        content,
        newsPostId,
        onDeletePost,
    }: Props,
): JSX.Element {
    const [now] = useState<number>(() => Date.now());
    const dateString = getApproximateTimeString(date, now);
    const authorDisplayName = authorName ?? 'Unknown';

    return (
        <div>
            <div className={styles.header}>
                <div>
                    <div className={styles.title}>
                        {title}
                    </div>
                    <div className={styles.subtitle}>
                        <PlayerAvatar src={authorAvatar ?? undefined} className={styles.author} /> {authorDisplayName} · {dateString} ago
                    </div>
                </div>
                <HomeNewsPostDeleteButton
                    newsPostId={newsPostId}
                    title={title}
                    onDeletePost={onDeletePost}
                />
            </div>

            <div className={styles.content}>
                {content}
            </div>
        </div>
    );
}
